import React, { useState, useEffect } from 'react';
import tableHelpers from '../helpers/TableHelpers.js'
import Tooltip from '../components/Tooltip.js'
import RichTable from '../components/richTable/RichTable.jsx'

function AlertEvaluationResults(props) {

    const [performance, setPerformance] = useState({})

    useEffect(() => {
        (async function () {
            if (props.performance)
                setPerformance(props.performance);
        })();
    }, [props.alertId, props.performance]);

    function dynamicFormatter(cell, row) {
        if (row.format === 'int')
            return tableHelpers.intFormatter(cell, row);
        else if (row.format === 'decimal')
            return tableHelpers.decimalFormatter(cell, row);
        else if (row.format === 'configPopup')
            return configFormatter(cell, row);
        else if (row.format === 'status')
            return statusPopupFormatter(cell, row);
        else if (row.format === 'metrics')
            return metricsFormatter(cell, row);
        else
            return tableHelpers.percentFormatter(cell, row);
    }

    function rowClass(row) {
        if (row.title === "Win %" || row.title === "Avg P/L" || row.title === "Avg Max Trade DD" || row.title === "CAGR" || row.title === "W/L Ratio") return "bold";
        else return "";
    }

    function getPerformanceRows() {
        console.log("performance row", performance);
        return [
            { title: 'Config', value: 'Last', format: 'configPopup' },
            { title: 'Count', value: performance.tradeCount, format: 'int' },
            { title: 'Avg Duration', value: performance.avgDurationInBars, format: 'int' },
            { title: 'Win %', value: performance.winningPercentage },
            { title: 'W/L Ratio', value: performance.winLossRatio, format: 'decimal' },
            { title: 'Avg P/L', value: performance.avgProfit },
            { title: 'Net Profit', value: performance.netProfit },
            { title: 'CAGR', value: performance.cagr },
            { title: 'Sharpe Ratio', value: performance.sharpeRatio, format: 'decimal' },
            { title: 'Max Drawdown', value: performance.maxDrawdown },
            { title: 'Avg Max Trade DD', value: performance.avgTradeMaxDrawdown },
            { title: 'Avg Win', value: performance.avgWin },
            { title: 'Avg Loss', value: performance.avgLoss },
            { title: 'Net Exposure', value: performance.netExposurePercent, format: 'percent' },
            { title: 'Max Loss', value: performance.maxLoss },
            { title: 'Max Trade DD', value: performance.maxTradeDrawdown },
            { title: 'Reward:Risk', value: performance.netProfit / performance.maxDrawdown, format: 'decimal' },
            { title: 'Trend Exits', value: performance.trendStopPercent, format: 'percent' },
            { title: 'Volatility Exits', value: performance.volatilityExitPercent, format: 'percent' },
            { title: 'Duration Exits', value: performance.durationExitPercent, format: 'percent' },
            { title: 'Profit Target Exits', value: performance.profitTargetExitPercent, format: 'percent' },
            { title: 'Stop Loss Exits', value: performance.stopLossExitPercent, format: 'percent' },
            { title: 'TStop Exits', value: performance.trailingStopExitPercent, format: 'percent' },
            { title: 'Strategy Exits', value: performance.standardExitPercent, format: 'percent' },
            { title: 'Current Bar', value: performance.currentBarStatus, format: 'status' },
            { title: 'Reason', value: performance.currentBarReason, format: 'status' },
            { title: 'All Metrics', value: performance, format: 'metrics' },
        ]
    }

    function configFormatter(cell, row) {
        return <Tooltip text={"Version " + cell} json={performance.config} />
    }

    function metricsFormatter(cell, row) {
        if (performance) {
            let metrics = JSON.parse(JSON.stringify(performance))
            metrics.trades = undefined;
            metrics.config = undefined;
            metrics.currentBarData = undefined;
            metrics.loserDurationsInDays = undefined;
            metrics.winnerDurationsInDays = undefined;
            return <Tooltip text={"Show"} json={metrics} position="left center" />
        } else
            return "None";
    }

    function statusPopupFormatter(cell, row) {
        return <Tooltip text={cell} json={performance.currentBarData} position="left center" />
    }

    return (
        <RichTable data={getPerformanceRows()} mappers={[
            { title: 'Name', field: 'title' },
            { title: 'Value', field: 'value', formatter: dynamicFormatter },
        ]} className="table-striped table-hover table-condensed" rowClassName={rowClass} />
    );
}

export default AlertEvaluationResults;